interface FormatPriceOptions {
  includeTax?: boolean;
  showTaxLabel?: boolean;
  locale?: string;
}

export function formatPrice(
  amount: number,
  options: FormatPriceOptions = {}
): string {
  const {
    includeTax = true,
    showTaxLabel = false,
    locale = 'fr-FR'
  } = options;

  const formattedAmount = amount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  let result = `${formattedAmount}€`;

  if (showTaxLabel) {
    result += includeTax ? ' TTC' : ' HT';
  }

  return result;
}

export function formatMonthlyPrice(yearlyPrice: number): string {
  const monthlyEquivalent = yearlyPrice / 12;
  return formatPrice(monthlyEquivalent);
}
